import { DecimalPipe } from "@angular/common";
import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";

@Pipe({ name: "localizedNumber", pure: false })
export class LocalizedNumberPipe implements PipeTransform, OnDestroy {
    lastNumber: number | null = null;
    lastFormat: string | null = null;
    onLangChange: Subscription | undefined;
    value = "";

    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly translateService = inject(TranslateService);

    updateValue(number: number, format?: string): void {
        const decimalPipe: DecimalPipe = new DecimalPipe(this.translateService.currentLang);
        this.value = format ? decimalPipe.transform(number, format) : decimalPipe.transform(number);

        this.lastNumber = number;
        this.lastFormat = format;
        this.changeDetectorRef.markForCheck();
    }

    transform(value: number, format?: string) {
        if (!value || !Number.isFinite(value)) return value;

        if (value === this.lastNumber && format === this.lastFormat) {
            return this.value;
        }
        this.lastNumber = value;
        this.lastFormat = format;
        this.updateValue(value, format);
        this.dispose();

        if (!this.onLangChange) {
            this.onLangChange = this.translateService.onLangChange.subscribe(() => {
                if (this.lastNumber) {
                    this.lastNumber = null;
                    this.updateValue(value, format);
                }
            });
        }

        return this.value;
    }

    private dispose() {
        if (this.onLangChange) {
            this.onLangChange.unsubscribe();
            this.onLangChange = undefined;
        }
    }

    ngOnDestroy() {
        this.dispose();
    }
}
